export default "__VITE_ASSET__3466484d__$_?nuxt_component=async__"